import Stack from "@mui/material/Stack"
import { useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/system"

import type { DateRange } from "types/date.types"
import type { EntityType } from "types/common.types"

import DateRangePicker from "widgets/dates/DateRangePicker"
import CsvButton from "widgets/csv/CsvButton"
import usePermissions from "helpers/hooks/usePermissions"

interface DashboardDatePickerProps {
  dateRange: DateRange | null
  dispatchDateRange: (dateRange: DateRange) => void
  entity?: EntityType
  isFetching?: boolean
}

const DashboardDatePicker = ({
  dateRange,
  dispatchDateRange,
  entity = "device",
  isFetching = false,
}: DashboardDatePickerProps) => {
  const theme = useTheme()
  const isMediumOrSmallDevice = useMediaQuery(theme.breakpoints.down("md"))
  const { isEditor } = usePermissions()

  return (
    <Stack
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: isMediumOrSmallDevice ? "space-between" : "end",
        width: isMediumOrSmallDevice ? "100%" : "fit-content",
        gap: 1,
        flexShrink: 0,
      }}
    >
      <DateRangePicker
        dateRange={dateRange}
        dispatchDateRange={dispatchDateRange}
        isFetching={isFetching}
        entity={entity}
      />
      {isEditor && <CsvButton entity={entity} />}
    </Stack>
  )
}

export default DashboardDatePicker
